import src from "IMAGE";
export default { src, width: 381, height: 80, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARElEQVR42hXKIRKAMAxE0aZkkw0CBQgUOAQzHUzvf7Sm4qv/iqoe2W6wJ8h/ZfRwtqXWTURQcp4TGXDT+U2UNTd/oXoNYB8DHnAaSXgAAAAASUVORK5CYII="};
